import {
  ALGOLIA_PRODUCT_OBJECT_ID_PREFIX,
  ALGOLIA_PRODUCT_SET_OBJECT_ID_PREFIX,
  getAlgoliaInsightsDataAttributes
} from 'lib/algolia'

import type { ProductTypes } from '../types/products'

// Short name every product set is published under - the only set marker available on
// listings, whose product details come from /products/by-ids and carry no `type` field.
// To be dropped once the backend payload exposes the type directly.
const PRODUCT_SET_NAME_SHORT = 'multipak'

const isProductSet = ({ type, nameShort }: ProductTypes) =>
  type ? type === 'set' : nameShort?.trim().toLowerCase() === PRODUCT_SET_NAME_SHORT

/** A product's identity in the Algolia index - model-prefixed, sets under their own prefix. */
export const getAlgoliaProductID = (product: ProductTypes) => {
  if (!product || typeof product !== 'object') return ''

  const { id = null } = product

  if (!id) return ''

  return `${isProductSet(product) ?
    ALGOLIA_PRODUCT_SET_OBJECT_ID_PREFIX
    : ALGOLIA_PRODUCT_OBJECT_ID_PREFIX}${id}`
}

/**
 * `data-insights-*` for a product tile: resolves the product to its objectID and
 * converts the 0-based list index to the 1-based position Algolia expects.
 *
 * There is no string counterpart on purpose - a plain objectID is already Algolia's
 * currency, so query suggestions call `getAlgoliaInsightsDataAttributes` from
 * `lib/algolia` directly with their own (already 1-based) position.
 */
export const getProductInsightsDataAttributes = (
  queryID: string | null | undefined,
  product: ProductTypes,
  idxOnList: number
) => getAlgoliaInsightsDataAttributes(queryID, getAlgoliaProductID(product), idxOnList + 1)
